import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import SaveToAccountCheckbox from 'components/RwdCheckout/Shared/PayPal/SaveToAccountCheckbox';
import EditDataActions from 'actions/EditDataActions';
import SaveToAccountCheckboxEN from 'components/RwdCheckout/Shared/PayPal/locales/SaveToAccountCheckbox_en_US.js';
import SaveToAccountCheckboxFR from 'components/RwdCheckout/Shared/PayPal/locales/SaveToAccountCheckbox_fr_CA.js';

const { updateEditData } = EditDataActions;

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(SaveToAccountCheckboxEN, SaveToAccountCheckboxFR);

const textResources = createStructuredSelector({
    saveToMyAccountCheckbox: getTextFromResource(getText, 'saveToMyAccountCheckbox')
});

const connectedSaveToAccountCheckbox = connect(
    createSelector(textResources, texts => {
        return texts;
    }),
    { updateEditData }
);

const witSaveToAccountCheckbox = wrapHOC(connectedSaveToAccountCheckbox);

export default witSaveToAccountCheckbox(SaveToAccountCheckbox);
